import React, { useState, useEffect } from 'react';

const Conclusao = () => {
	return <div className='text-3xl '> CONCLUSÃO DE VIOLENCIA</div>;
};

export default Conclusao;
